import * as React from "react";
import BaseComponent from "src/engine/ui/BaseComponent";
import "./index.scss";

interface IProps {
    onClose: () => void;
}

interface IState {}

// 领取下载奖励成功弹窗
class DrawModal extends BaseComponent<IProps, IState> {
    render() {
        const { onClose } = this.props;

        return (
            <div className="draw-success-modal">
                <div className="draw-content">
                    <div className="btn-close" onClick={onClose}></div>
                    <div className="draw-box">
                        <div className="draw-pic"></div>
                        <div className="draw-pic-des">如何在游戏内领取皮肤</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default DrawModal;
